export const ACTIONS_YANDEX = {
  ADD_PRODUCTS: 'ADD_YANDEX_PRODUCTS',
  CHANGE_PRODUCT: 'CHANGE_YANDEX_PRODUCT',
  CHANGE_MARKET: 'CHANGE_YANDEX_MARKET',
};

export const addYandexProducts = data => ({
  type: ACTIONS_YANDEX.ADD_PRODUCTS,
  data,
});

export const actionChangeYandexProduct = (product = {}) => ({
  type: ACTIONS_YANDEX.CHANGE_PRODUCT,
  product,
});

export const changeYandexMarket = market => ({
  type: ACTIONS_YANDEX.CHANGE_MARKET,
  market,
});
